/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BrandAndMarketPermissionResponse,
    BrandAndMarketPermissionResponseFromJSON,
    BrandAndMarketPermissionResponseToJSON,
    CabinTypeResponse,
    CabinTypeResponseFromJSON,
    CabinTypeResponseToJSON,
    FareTypeResponse,
    FareTypeResponseFromJSON,
    FareTypeResponseToJSON,
    FeatureType,
    FeatureTypeFromJSON,
    FeatureTypeToJSON,
    JourneyTypeResponse,
    JourneyTypeResponseFromJSON,
    JourneyTypeResponseToJSON,
    RelevanceResponse,
    RelevanceResponseFromJSON,
    RelevanceResponseToJSON,
} from '../models';

export interface ApiV2BusinessDataBrandandmarketsTypeGetRequest {
    type: FeatureType;
}

/**
 * no description
 */
export class BusinessDataApi extends runtime.BaseAPI {

    /**
     */
    async apiV2BusinessDataBrandandmarketsTypeGetRaw(requestParameters: ApiV2BusinessDataBrandandmarketsTypeGetRequest): Promise<runtime.ApiResponse<Array<BrandAndMarketPermissionResponse>>> {
        if (requestParameters.type === null || requestParameters.type === undefined) {
            throw new runtime.RequiredError('type','Required parameter requestParameters.type was null or undefined when calling apiV2BusinessDataBrandandmarketsTypeGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/BusinessData/brandandmarkets/{type}`.replace(`{${"type"}}`, encodeURIComponent(String(requestParameters.type))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BrandAndMarketPermissionResponseFromJSON));
    }

    /**
     */
    async apiV2BusinessDataBrandandmarketsTypeGet(requestParameters: ApiV2BusinessDataBrandandmarketsTypeGetRequest): Promise<Array<BrandAndMarketPermissionResponse>> {
        const response = await this.apiV2BusinessDataBrandandmarketsTypeGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiV2BusinessDataCabintypesGetRaw(): Promise<runtime.ApiResponse<Array<CabinTypeResponse>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/BusinessData/cabintypes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CabinTypeResponseFromJSON));
    }

    /**
     */
    async apiV2BusinessDataCabintypesGet(): Promise<Array<CabinTypeResponse>> {
        const response = await this.apiV2BusinessDataCabintypesGetRaw();
        return await response.value();
    }

    /**
     */
    async apiV2BusinessDataFaretypesGetRaw(): Promise<runtime.ApiResponse<Array<FareTypeResponse>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/BusinessData/faretypes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FareTypeResponseFromJSON));
    }

    /**
     */
    async apiV2BusinessDataFaretypesGet(): Promise<Array<FareTypeResponse>> {
        const response = await this.apiV2BusinessDataFaretypesGetRaw();
        return await response.value();
    }

    /**
     */
    async apiV2BusinessDataJourneytypesGetRaw(): Promise<runtime.ApiResponse<Array<JourneyTypeResponse>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/BusinessData/journeytypes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(JourneyTypeResponseFromJSON));
    }

    /**
     */
    async apiV2BusinessDataJourneytypesGet(): Promise<Array<JourneyTypeResponse>> {
        const response = await this.apiV2BusinessDataJourneytypesGetRaw();
        return await response.value();
    }

    /**
     */
    async apiV2BusinessDataRelevancesGetRaw(): Promise<runtime.ApiResponse<Array<RelevanceResponse>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/BusinessData/relevances`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RelevanceResponseFromJSON));
    }

    /**
     */
    async apiV2BusinessDataRelevancesGet(): Promise<Array<RelevanceResponse>> {
        const response = await this.apiV2BusinessDataRelevancesGetRaw();
        return await response.value();
    }

}
